import {DataItems} from '@convincely/components/src/components/Item/DataItems.js';
import {writable} from '@convincely/components/src/library.js';

export * from './funnel.js';
export const trustStore = new DataItems([]);
export const formStore = writable({});
export const fontStore = writable([]);
export const widgetStore = writable({heading: window.funnel_header, components: [], customContainer: false, listView: false});
export const headerStore = writable({components: []});
export const preResultStore = writable({components: []});
export const hideStore = writable([]);
export const mainHeaderStore = writable({components: []});
export const topStore = writable({components: []});
export const bottomStore = writable({components: [], opts: {}});
export const sideStore = writable({blur: false, components: []});
export const flowStore = writable({});
export const panelStore = writable({});
export const successStore = writable({heading: '', components: [], hideSidePanel: false});
export const failureStore = writable({heading: '', components: []});
export const resultStore = writable(successStore);
export const assetStore = writable({loader: {}, close: {}, success: {}});
export const leadStore = writable({heading: '', content: '', backgrounds: [], inputs: [], button: {}, note: '', opts: {}, submitted: false, show: false, openByStep: false, leadCaptureOpened: false});
export const funnelStore = writable({delayAppinjection: false, widget: true, open: false, browserWarning: {beforeHeader: false}});
export const inputMap = writable({});
export const dataStore = writable();
export const modalStore = writable({index: 0});
export const definitionsStore = writable({});
export const wentNext = writable(false);
export const funnelSessionTimer = writable({start: null, stop: null, elapsed: null});

export function addData(name, data) {
  dataStore.update((map) => ({...map, [name]: data}));
}

export function setInputMap(name, value) {
  inputMap.update((map) => ({...map, [name]: value}));

  return value;
}

export function setWidgetStep(step) {
  widgetStore.update((obj) => ({...obj, step}));
}

export function startFunnelSessionTimer() {
  funnelSessionTimer.set({
    start: new Date().getTime(),
    stop: null,
    elapsed: null,
  });
}

export function stopFunnelSessionTimer() {
  funnelSessionTimer.update((data) => {
    const now = new Date().getTime();

    return {
      ...data,
      stop: now,
      elapsed: now - data.start,
    };
  });
}

export function updatePhoneDetails(phoneNumber, phoneNumberLink) {
  headerStore.update((map) => ({
    ...map,
    phone: phoneNumber,
    phoneLink: phoneNumberLink,
  }));
}

export function updateRedirectUrls(redirectUrl) {
  funnelStore.update((map) => ({
    ...map,
    redirectUrl,
  }));
}
